import Resource from '@/plugins/sdk/Resource'
import { NUMBER, INTEGER, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'consignment_item_contents'

  static get fields () {
    return {
      id: new UUID(),
      origin: new STRING(),
      description: new STRING(),
      quantity: new INTEGER(),
      value: new NUMBER(),
      weight: new NUMBER(),
      tariff_code: new STRING()
    }
  }
}
